import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EstatusJSON } from "../../models/EstatusJSON";
import { environment } from "src/environments/environment";
import { CatalogPaginationRequest } from "../../models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../models/Filter/FilterRequest";
import { IApiBase } from "./Interface/IApiBase.interface";

@Injectable({
  providedIn: "root",
})
export class ControlPanelAPIService implements IApiBase {
  
  configUrl: string;
  public Result;
  estatus: EstatusJSON;
  constructor(private http: HttpClient) {
    this.configUrl = environment.host;
    this.estatus = new EstatusJSON();
  }
  delete(id: any) {
    throw new Error("Method not implemented.");
  }
  insert() {
    throw new Error("Method not implemented.");
  }
  update(datos: any) {
    throw new Error("Method not implemented.");
  }

  getResume(month: number): any {
    if(!environment.production) console.log("/api/controlPanel/GetResume?month=" + month);
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/controlPanel/GetResume?month=" + month, {}
    );
  }

  
  //paginacion
  getFilterValues(request : FilterRequest[]) {
    return this.http.post<EstatusJSON>(this.configUrl + "/api/Alarms/GetFilterValues", request);
  }

  getPage(request : CatalogPaginationRequest) {
    return this.http.post<EstatusJSON>(this.configUrl + "/api/Alarms/GetPage", request);
  }
  getCount(request : CatalogPaginationRequest) {
    return this.http.post<EstatusJSON>(this.configUrl + "/api/Alarms/GetFilteredCount", request);
  }
  
}
